<template>
  <div class="px-4 mb-2">
    <SelectModuleButton
      class="py-1"
      data-qa="service_select_synonym_button"
      :title="selectedSynonym.name"
      :subtitle="getFormattedPrice(selectedSynonym.price)"
      @click="handleClickSelect"
    >
      <template #subtitle>
        <template v-if="isUsedClub">
          <span
            v-if="formattedSelectedSynonym.priceWithDiscount"
            class="error--text pr-1"
          >
            {{ getFormattedPrice(formattedSelectedSynonym.priceWithDiscount) }}
            <template v-if="selectedSynonym.duration">
              &bull; {{ getDurationText(selectedSynonym.duration) }}
            </template>
          </span>
          <span :class="{ 'text-decoration-line-through': formattedSelectedSynonym.priceWithDiscount }">
            {{ getFormattedPrice(selectedSynonym.price) }}
            <template v-if="selectedSynonym.duration">
              &bull; {{ getDurationText(selectedSynonym.duration) }}
            </template>
          </span>
        </template>
        <template v-else>
          {{ getFormattedPrice(selectedSynonym.price) }}
          <template v-if="selectedSynonym.duration">
            &bull; {{ getDurationText(selectedSynonym.duration) }}
          </template>
        </template>
      </template>
    </SelectModuleButton>
    <CoreDialog
      v-model="isVisibleError"
      data-qa="service_select_synonym_error"
      size="sm"
      title="Произошла ошибка"
    >
      <div class="text-body-1 text-secondary--text">
        Попробуйте ещё раз.
      </div>
      <template #actions>
        <v-btn
          data-qa="modal-actions-btn-close"
          color="primary"
          text
          @click="isVisibleError = false"
        >
          Понятно
        </v-btn>
      </template>
    </CoreDialog>
    <CoreDialog
      :value="isVisibleModal"
      data-qa="service_synonym_modal"
      size="fullscreen"
      :title="modalTitle"
      divider
      persistent
      hide-overlay
      no-click-animation
      transition="fade-transition"
    >
      <template #prependBtn="{ btnProps }">
        <v-btn
          v-bind="btnProps"
          @click="handleClickModalBack"
        >
          <span :class="isStackRoot ? 'ui-icon-close-not-a-circle' : 'ui-icon-arrow-back'" />
        </v-btn>
      </template>
      <template #extension>
        <SynonymListSearch
          ref="synonymListSearchComponent"
          :synonym-data="ajaxSynonymData"
          :is-loading="isLoadingSynonym"
          @search:found-results="handleSearchFoundResults"
        />
      </template>
      <template #default="{ counterXSpaceClass, xSpaceClass }">
        <SynonymListSearchEmpty
          v-if="isSearchResultsEmpty"
        />
        <SynonymListItems
          v-else
          :is-used-club="isUsedClub"
          :synonym-list="activeSynonymList"
          :diagnostic-level="diagnosticLevel"
          :is-loading-synonym="isLoadingSynonym"
          :is-search-results="hasSearchResults"
          :counter-x-space-class="counterXSpaceClass"
          :x-space-class="xSpaceClass"
          @synonym-list:click-item="handleClickSynonymItem"
        />
      </template>
    </CoreDialog>
  </div>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import SelectModuleButton from 'www/vue_components/common/SelectModule/SelectModuleModal/components/common/SelectModuleButton.vue'
import SynonymListSearch from 'www/vue_components/common/SynonymList/components/common/SynonymListSearch.vue'
import SynonymListSearchEmpty from 'www/vue_components/common/SynonymList/components/common/SynonymListSearchEmpty.vue'
import SynonymListItems from 'www/vue_components/common/SynonymList/components/common/SynonymListItems.vue'
import SynonymListLogic from 'www/vue_components/common/SynonymList/mixins/SynonymListLogic'

export default {
  name: 'SynonymList',
  vuetify,
  components: {
    CoreDialog,
    SelectModuleButton,
    SynonymListSearch,
    SynonymListSearchEmpty,
    SynonymListItems,
  },
  mixins: [
    SynonymListLogic,
  ],
}
</script>
